const PIE_CHART_ICON_WIDTH_PX = 11;
const INCOMPLETE_PIE_CHART_ICON_STROKE_WIDTH_PX = 2;
const COMPLETE_PIE_CHART_ICON_STROKE_WIDTH_PX = 3;

type PieChartIconProps = {
  /* A number between 0 and 100 */
  percentage: number;
  /* Optional pixel width of pie chart icon */
  pxWidth?: number;
  thinStroke?: number;
  fullStroke?: number;
};

export const isValidNumber = (pxValue: number) => !Number.isNaN(Number(pxValue));

export const PieChartIcon = ({
  percentage: unformattedPercentage,
  pxWidth = PIE_CHART_ICON_WIDTH_PX,
  thinStroke = INCOMPLETE_PIE_CHART_ICON_STROKE_WIDTH_PX,
  fullStroke = COMPLETE_PIE_CHART_ICON_STROKE_WIDTH_PX,
}: PieChartIconProps) => {
  const percentage = Math.min(100, Math.max(0, unformattedPercentage)) / 100;
  const incompleteStroke = isValidNumber(thinStroke)
    ? thinStroke
    : INCOMPLETE_PIE_CHART_ICON_STROKE_WIDTH_PX;
  const completeStroke = isValidNumber(fullStroke)
    ? fullStroke
    : COMPLETE_PIE_CHART_ICON_STROKE_WIDTH_PX;
  const strokeWidth = percentage === 1 ? completeStroke : incompleteStroke;
  const iconWidth = isValidNumber(pxWidth) ? pxWidth : PIE_CHART_ICON_WIDTH_PX;
  const center = iconWidth / 2;
  const radius = iconWidth / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  return (
    <svg
      height={iconWidth}
      width={iconWidth}
      viewBox={`0 0 ${iconWidth} ${iconWidth}`}
      data-test={`pie-chart-icon-${percentage}`}
    >
      <circle
        r={radius}
        cx={center}
        cy={center}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeOpacity="20%"
        fill="transparent"
      />
      <circle
        r={radius}
        cx={center}
        cy={center}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeDasharray={`${circumference * percentage} ${circumference}`}
        fill="transparent"
        transform={`scale(1, -1) rotate(90) translate(-${iconWidth}, -${iconWidth})`}
      />
    </svg>
  );
};
